// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1c7fbfba","455":"b374254f","977":"a4baa267"}[chunkId] + ".chunk.js";
};